import React, { useEffect, useRef } from "react"
import { concatStrings } from "../utilities"
import DfbIcon from "../ui-kit/dfb_icon"

/**
 * The modal uses javascript logic outside react.
 * It has to be opened using a function of the modal element:
 * <code>modalRef.current.dfbModal.open()</code>
 * Where "modalRef" is the reference that is passed to the modal.
 *
 * @param ref The reference that can be used to access the modal element (see above)
 * @param {string} props.id The id of the modal (required)
 * @param {string} props.children The additional content that is shown between headline and buttons
 * @param {boolean} props.hideCloseIcon Set to true to hide the close icon (default false)
 * @param {boolean} props.autoOpen When set to true the modal is opened directly
 */
const CModalBase = React.forwardRef(
  (
    {
      id,
      autoOpen,
      hideCloseIcon,
      children,
      add_class
    },
    ref
  ) => {

    const modalRef = ref || useRef();

    const autoOpener = () => {
      if (modalRef.current && modalRef.current.dfbModal) {
        modalRef.current.dfbModal.open()
      } else {
        setTimeout(autoOpener, 100);
      }
    }

    useEffect(() => {
      if (autoOpen) {
        autoOpener();
      }
    }, [])

    return (
      <div
        ref={modalRef}
        className={concatStrings("dfb-Modal", add_class)}
        role="dialog"
        tabIndex="-1"
        id={id}
        style={{ zIndex: 5001 }}
      >
        <div className="dfb-Modal-surface">
          <div className="dfb-Modal-container">
            <div className="dfb-Modal-content" role="document" tabIndex="-1">
              <div className="dfb-Modal-contentContainer">
                {!hideCloseIcon && (
                  <button
                    type="button"
                    className="dfb-Modal-dismissButton"
                    data-dismiss="modal"
                    data-testid="close-modal-dialog"
                  >
                    <DfbIcon icon_type="close" />
                  </button>
                )}
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
)

export default CModalBase
